import { startOfMonth, startOfWeek, addDays, eachDayOfInterval, isSameDay, isSameMonth, isBefore, isAfter, startOfDay, } from 'date-fns';
const WEEK_STARTS_ON = 1;
// Always render 6 full weeks so the grid height is constant across months
const CALENDAR_WEEKS_COUNT = 6;
const CALENDAR_DAYS_COUNT = CALENDAR_WEEKS_COUNT * 7;
export const getCalendarDates = ({ currentDate, selectedDate, minDate, maxDate, getIsDisabled, }) => {
    const startCurrentMonth = startOfMonth(currentDate);
    const startDate = startOfWeek(startCurrentMonth, {
        weekStartsOn: WEEK_STARTS_ON,
    });
    const endDate = addDays(startDate, CALENDAR_DAYS_COUNT - 1);
    const daysOfMonth = eachDayOfInterval({
        start: startDate,
        end: endDate,
    });
    const calendarDays = daysOfMonth.map((day) => {
        const isBeforeMinDate = minDate
            ? isBefore(day, startOfDay(minDate))
            : false;
        const isAfterMaxDate = maxDate ? isAfter(day, startOfDay(maxDate)) : false;
        const isOutOfRange = isBeforeMinDate || isAfterMaxDate;
        const isOutOfCurrentMonth = !isSameMonth(day, currentDate);
        const isCurrentDay = isSameDay(day, new Date());
        const isSelectedDay = selectedDate ? isSameDay(day, selectedDate) : false;
        const isExplicitlyBlocked = getIsDisabled?.(day) ?? false;
        const isBlockedDay = isOutOfRange || isExplicitlyBlocked;
        return {
            day,
            isCurrentDay,
            isOutOfCurrentMonth,
            isSelectedDay,
            isBlockedDay,
        };
    });
    return calendarDays;
};
